<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Values and hobbies</h3>
    <div class="dialog-header__icons">
      <i
        *ngIf="ableToEdit"
        [class.grey]="isEditable"
        (click)="switchEdit()"
        class="icon-pencil"
      ></i>
      <i class="icon-close icon big-close" DialogClose></i>
    </div>
  </div>
  <!---------- main content ---------->
  <div class="dialog-content__container">
    <form [formGroup]="valuesAndHobbiesForm">
      <fieldset [disabled]="!isEditable" class="form__fieldset">
        <div class="container">
          <div class="row mt-16 mb-16">
            <p
              class="col-3"
              appMarkAsterisk
              [formGroup]="valuesAndHobbiesForm"
              [controlName]="'values'"
              [touched]="valuesAndHobbiesForm.get('values')!.touched"
            >
              Values
            </p>
            <div class="col-8 relative">
              <textarea
                type="text"
                placeholder=" "
                class="input__basic"
                formControlName="values"
              ></textarea>
              <app-error-field
                [displayError]="
                  valuesAndHobbiesForm.get('values')!.hasError('required') &&  valuesAndHobbiesForm.get('values')!.touched
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
              <app-error-field
                [displayError]="
                  valuesAndHobbiesForm.get('values')!.hasError('wordCount') && valuesAndHobbiesForm.get('values')!.touched
                "
                [errorMessage]="'Max field length = 400 words'"
              ></app-error-field>
            </div>
          </div>
          <div class="row mb-16">
            <p
              class="col-3"
              appMarkAsterisk
              [formGroup]="valuesAndHobbiesForm"
              [controlName]="'hobbies'"
              [touched]="valuesAndHobbiesForm.get('hobbies')!.touched"
            >
              Hobbies
            </p>
            <div class="col-8 relative">
              <textarea
                type="text"
                placeholder=" "
                class="input__basic"
                formControlName="hobbies"
              ></textarea>
              <app-error-field
                [displayError]="
                  valuesAndHobbiesForm.get('hobbies')!.hasError('required') &&  valuesAndHobbiesForm.get('hobbies')!.touched
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
              <app-error-field
                [displayError]="
                  valuesAndHobbiesForm.get('hobbies')!.hasError('wordCount') &&  valuesAndHobbiesForm.get('hobbies')!.touched
                "
                [errorMessage]="'Max field length = 400 words'"
              ></app-error-field>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0" *ngIf="isEditable">
      <button class="button button__save add-margin" (click)="saveData()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancelSave()">
        Cancel
      </button>
    </div>
  </div>
</div>
